import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <Link to="/terms-condition" className="site-footer__text">
          Terms & Conditions
        </Link>

        <Link to="/privacy-policy" className="site-footer__text">
          Privacy Policy
        </Link>

        {/* <span className="site-footer__text">© 2026 Copyright, All Right Reserved</span> */}
      </div>
    </footer>
  );
};

export default Footer;